import React from 'react';
import { Spin } from 'antd';
import { isEqual, isEmpty } from 'lodash';
import {WeaErrorPage, WeaLocaleProvider, WeaTools} from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;
const { ls } = WeaTools;
import Title from './Title';
import { ContactsCom, SearchInput } from './Contacts';
//内容组件
class EContent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tabdata: props.edata.data,
            currentTab: props.edata.currenttab,
            refresh: false,
        }
        this.handleTabData = this.handleTabData.bind(this);
        this.searchContacts = this.searchContacts.bind(this);
    }
    componentWillReceiveProps(nextProps){
        if(!isEqual(nextProps, this.props)){
            this.setState({
                tabdata: nextProps.edata.data,
                currentTab: nextProps.edata.currenttab,
                refresh: false,
            }); 
        }
    }
    shouldComponentUpdate(nextProps, nextState){
        return !isEqual(this.state, nextState) || !isEqual(this.props, nextProps)
    }
    componentDidMount(){
        this.props.onRef(this);
    }
    handleTabData(tabid, value){
        const { params, isremembertab } = this.props.config;
        const { currentTab } = this.state;
        const tabdata_local = ls.getJSONObj('tabdata-' + params.eid + '-' + tabid);
        this.setState({
            refresh: tabid === currentTab,
            currentTab: tabid,
            tabdata: tabdata_local == null ? {} : tabdata_local,
        });
        WeaTools.callApi('/api/portal/element/contactstab', 'POST', {...params, tabid, key: typeof value == 'string'?value: ''}).then(result => {
            ls.set('tabdata-' + params.eid + '-' + tabid, result);
            if(tabid === this.state.currentTab){
                this.setState({
                    tabdata: result,
                    refresh: false,
                });
                if(isremembertab){
                    let edata = ls.getJSONObj('edata-' + params.eid);
                    if(edata){
                        edata.currenttab = tabid;
                        edata.data = result;
                        ls.set('edata-' + params.eid, edata);
                    }
                }
            }
       });
    }
    searchContacts(value){
        this.handleTabData(this.state.currentTab, value)
    }
    render() {
        const { config, edata, handleRefresh, handleDelete, fontSizeMp } = this.props;
        const { tabdata, currentTab, refresh } = this.state;
        const { tabids, titles, esetting } = edata;
        const { dataColoums=[] } = tabdata;
        let { fontStyle } = config.item;
        if(!isEmpty(fontSizeMp)) fontStyle = fontSizeMp;
        esetting.fontStyle = fontStyle;
        esetting.dataColoums = dataColoums;
        const { eid } = config.params;
        const { contentview = {} } = config.item;
        const cstyle = tabids && tabids.length > 1 && contentview.style && contentview.style.height ? {height: parseInt(contentview.style.height)-32+"px",overflow: "auto"} : {};
        let contentHtml = tabdata && tabdata.data.length ? <ContactsCom eid={eid} list={tabdata.data} esetting={esetting}/> : <div/>;
        const _titleProps = {
            currentTab,
            config,
            titles,
            tabids,
            handleRefresh,
            handleDelete,
            fontSizeMp,
            tabwidth: esetting.tabwidth,
            tabwimethodvaluedth: esetting.methodvalue,
            handleTabData: this.handleTabData
        }
        return <div>
            <SearchInput placeholder={getLabel(83815,"搜索姓名/首字母/手机号")} type="contacts" onSearch={this.searchContacts} style={{width:'300px',marginTop:'5px'}}/>
            <Title {..._titleProps}/>
            {/*<div className="tabContant" id={`tabcontant_${eid}`} style={cstyle}>*/}
            <div className="tabContant" id={`tabcontant_${eid}`}>
                <Spin spinning={refresh}>{contentHtml}</Spin>
            </div>
         </div>;
    }
}

class MyErrorHandler extends React.Component {
    render() {
        const hasErrorMsg = this.props.error && this.props.error !== "";
            return ( <WeaErrorPage msg = { hasErrorMsg ? this.props.error : getLabel(385218,"对不起，该页面异常，请联系管理员！")}/>
        );
    }
}
EContent = WeaTools.tryCatch(React, MyErrorHandler, { error: "" })(EContent);
export default EContent;



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal/elements/components/contacts/EContent.js